import { createFileRoute } from "@tanstack/react-router"
import { ApplyResetPassword } from "@/app"

export const Route = createFileRoute("/(public)/auth/reset-password/$token")({
  component: RouteComponent,
  validateSearch: (search) => search as { token: string },
})

function RouteComponent() {
  const { token } = Route.useParams()

  return <ApplyResetPassword token={token} />
}
